export enum TransactionType {
    Activate,
    Redeem,
    Reload,
    Balance,
    Tor,
    Void,
    
    FINAL_ENUM
}


// WEBPACK FOOTER //
// ./Scripts/utils/Common.ts